/* Destilo — Favorites page.
   Reads saved product handles from localStorage, fetches each card via the
   Section Rendering API, then paginates them like a collection (numbered pages,
   N per page) and wires add-to-cart + un-favoriting. */
(function () {
  const money = (cents) =>
    (cents / 100).toLocaleString('es-ES', {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
    });

  const KEY = 'destilo_wishlist';
  const read = () => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  };
  const write = (l) => {
    localStorage.setItem(KEY, JSON.stringify(l));
    /* Sube el cambio a la cuenta si hay sesión (assets/wishlist-sync.js). */
    if (window.DestiloWishlistSync) window.DestiloWishlistSync.push();
  };

  const HEART_SVG =
    '<svg viewBox="-1 -1 20 19.5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.8754 1.85151C15.9183 0.675074 14.467 0 12.8922 0C11.2272 0 9.95812 1.33476 9.11833 2.21653C9.07854 2.25831 9.03875 2.30009 8.99896 2.34187C8.96126 2.30229 8.92147 2.26051 8.87959 2.21653C8.0398 1.33256 6.77278 0 5.10786 0C3.53299 0 2.08168 0.675074 1.12461 1.85151C0.211523 2.97297 -0.16544 4.43526 0.0670204 5.96352C0.314141 7.59734 2.2911 10.4713 4.05864 12.6153C5.72566 14.6383 8.01885 17 9.00105 17C9.98325 17 12.2764 14.6383 13.9435 12.6153C15.711 10.4713 17.6859 7.59734 17.933 5.96352C18.1634 4.43306 17.7885 2.97297 16.8754 1.85151Z"/></svg>';
  const STAR_SVG =
    '<svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.84982 8.98657L5.01455 7.58745L2.16961 8.99722L1.91655 8.96072C1.85691 8.95159 1.81339 8.79495 1.79888 8.72956L2.34208 5.77924L0.0419517 3.64254C-0.0418652 3.50414 0.00487885 3.3323 0.141887 3.23497L3.36078 2.7985L4.77922 0.105192C4.8453 -0.0195123 5.10804 -0.0301578 5.22893 0.0610892L6.67155 2.7985L9.74537 3.2228C9.82113 3.23344 10.0017 3.28211 10 3.3475L9.99198 3.64406L7.68863 5.77772L8.22377 8.66569L8.16413 8.91662C8.14801 8.98505 7.91913 9.01851 7.84982 8.98505V8.98657Z" fill="currentColor"/></svg>';
  const RESERVED = ['staff pick', 'staff-pick', 'new', 'gift', 'gift idea', 'gift ideas', 'non-alcoholic', 'low-mindful', 'spirits', 'snacks', 'sample-boxes'];
  const CARET_SVG =
    '<svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg>';

  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* Build a ps-card from a product JSON (/products/{handle}.js) */
  function buildCard(p) {
    const variants = p.variants || [];
    const variant = variants.find((v) => v.available) || variants[0] || {};
    const available = !!variant.available;
    const price = variant.price != null ? variant.price : p.price;
    const url = '/products/' + p.handle;
    const tags = p.tags || [];
    const isStaff = tags.some((t) => ['staff pick', 'staff-pick'].indexOf(String(t).toLowerCase()) > -1);
    const pills = tags
      .filter((t) => {
        const tl = String(t).toLowerCase();
        return RESERVED.indexOf(tl) === -1 && tl.indexOf('familia:') !== 0;
      })
      .slice(0, 3);

    const media = p.featured_image
      ? '<img src="' + esc(p.featured_image) + '" alt="' + esc(p.title) + '" loading="lazy">'
      : '<span class="ps-card__placeholder-box"></span>';
    const addLabel = available ? 'Add to cart — ' + money(price) : 'Sold out';

    const el = document.createElement('div');
    el.className = 'ps-card';
    el.dataset.productId = p.id;
    el.dataset.price = price;
    el.innerHTML =
      '<div class="ps-card__media">' +
      (isStaff ? '<span class="ps-card__badge">' + STAR_SVG + ' Staff Pick</span>' : '') +
      '<a href="' + url + '" class="ps-card__image-link" tabindex="-1" aria-hidden="true">' + media + '</a>' +
      '<div class="ps-card__cart" data-variant-id="' + variant.id + '">' +
      '<button type="button" class="ps-card__add"' + (available ? '' : ' disabled') + '>' +
      '<span class="ps-card__add-label">' + addLabel + '</span>' +
      '</button>' +
      '<div class="ps-card__qty">' +
      '<button type="button" class="ps-card__qty-btn" data-action="decrease" aria-label="Quitar uno">−</button>' +
      '<span class="ps-card__qty-label"></span>' +
      '<button type="button" class="ps-card__qty-btn" data-action="increase" aria-label="Añadir uno">+</button>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '<div class="ps-card__info">' +
      '<div class="ps-card__title-row">' +
      '<a href="' + url + '" class="ps-card__name">' + esc(p.title) + '</a>' +
      '<button type="button" class="ps-card__wishlist is-active" aria-label="Quitar de favoritos" data-product-id="' +
      p.id + '" data-product-handle="' + esc(p.handle) + '">' + HEART_SVG + '</button>' +
      '</div>' +
      (pills.length
        ? '<div class="ps-card__meta"><div class="ps-card__tags">' +
          pills.map((t) => '<span class="ps-card__tag">' + esc(t) + '</span>').join('') +
          '</div></div>'
        : '') +
      '</div>';
    return el;
  }

  let allCards = [];
  let perPage = 16;
  let currentPage = 1;
  let rootEl, gridEl, navEl, emptyEl;
  let cartSync = null;

  function totalPages() {
    return Math.max(1, Math.ceil(allCards.length / perPage));
  }

  function handleOf(card) {
    const w = card.querySelector('.ps-card__wishlist');
    return w ? w.dataset.productHandle : '';
  }

  function buildNav() {
    const total = totalPages();
    if (total <= 1) {
      navEl.innerHTML = '';
      return;
    }
    let items = '';
    if (currentPage > 1) {
      items +=
        '<li><a role="button" tabindex="0" data-page="' + (currentPage - 1) +
        '" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce" aria-label="Anterior"><span class="svg-wrapper">' +
        CARET_SVG + '</span></a></li>';
    }
    for (let i = 1; i <= total; i++) {
      items +=
        i === currentPage
          ? '<li><a role="link" aria-disabled="true" class="pagination__item pagination__item--current light" aria-current="page">' + i + '</a></li>'
          : '<li><a role="button" tabindex="0" data-page="' + i + '" class="pagination__item link">' + i + '</a></li>';
    }
    if (currentPage < total) {
      items +=
        '<li><a role="button" tabindex="0" data-page="' + (currentPage + 1) +
        '" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce" aria-label="Siguiente"><span class="svg-wrapper">' +
        CARET_SVG + '</span></a></li>';
    }
    navEl.innerHTML =
      '<div class="pagination-wrapper"><nav class="pagination" role="navigation" aria-label="Paginación"><ul class="pagination__list list-unstyled" role="list">' +
      items +
      '</ul></nav></div>';
  }

  function renderPage(p, scroll) {
    currentPage = Math.min(Math.max(1, p), totalPages());
    gridEl.innerHTML = '';
    const start = (currentPage - 1) * perPage;
    allCards.slice(start, start + perPage).forEach((c) => gridEl.appendChild(c));
    // Las tarjetas van dentro de .products-showcase__grid, cuyos hijos nacen con
    // opacity:0 esperando a que el observador de destilo-reveal.js les ponga
    // .da-in. Ese observador solo mira una vez, al cargar la página, así que
    // estas —que se inyectan después— se quedarían invisibles para siempre.
    // Mismo apaño que en pdp-related.js.
    gridEl.querySelectorAll('.ps-card').forEach((c) => c.classList.add('da-in'));
    buildNav();
    if (cartSync) cartSync();
    if (scroll) {
      window.scrollTo({ top: rootEl.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
    }
  }

  /* ---- ps-card add-to-cart (same behaviour as the showcase) ---- */
  function bindCart(root) {
    const state = {};
    const getQty = (v) => state[v] || 0;

    async function refresh() {
      try {
        const cart = await fetch('/cart.js').then((r) => r.json());
        Object.keys(state).forEach((k) => delete state[k]);
        cart.items.forEach((i) => { state[i.variant_id] = i.quantity; });
      } catch (e) {
        /* noop */
      }
    }
    function renderCard(cartEl, qty) {
      const lbl = cartEl.querySelector('.ps-card__qty-label');
      if (qty > 0) {
        cartEl.classList.add('is-in-cart');
        const unit = parseInt(cartEl.closest('.ps-card').dataset.price, 10) || 0;
        if (lbl) lbl.textContent = qty + ' en el carrito — ' + money(unit * qty);
      } else {
        cartEl.classList.remove('is-in-cart');
      }
    }
    async function sync() {
      await refresh();
      root.querySelectorAll('.ps-card__cart').forEach((el) => renderCard(el, getQty(el.dataset.variantId)));
    }
    function applySections(cart, json) {
      if (!json.sections) return;
      cart.getSectionsToRender().forEach((section) => {
        const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        const html = json.sections[section.id];
        if (!target || html == null) return;
        const src = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector || '.shopify-section');
        target.innerHTML = src ? src.innerHTML : html;
      });
      const overlay = document.querySelector('#CartDrawer-Overlay');
      if (overlay && typeof cart.close === 'function') overlay.addEventListener('click', cart.close.bind(cart));
      const total = Object.values(state).reduce((a, b) => a + b, 0);
      cart.classList.toggle('is-empty', total === 0);
    }
    async function change(variantId, quantity, cartEl) {
      quantity = Math.max(0, quantity);
      const isAdd = getQty(variantId) === 0 && quantity > 0;
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const ids = cart && cart.getSectionsToRender ? cart.getSectionsToRender().map((s) => s.id) : ['cart-icon-bubble'];
      const payload = { sections: ids.join(','), sections_url: window.location.pathname };
      try {
        let res;
        if (isAdd) {
          res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }], ...payload }),
          });
        } else {
          res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: String(variantId), quantity: quantity, ...payload }),
          });
        }
        const json = await res.json();
        await refresh();
        renderCard(cartEl, getQty(variantId));
        if (cart && cart.getSectionsToRender) applySections(cart, json);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'favorites', cartData: json });
        }
      } catch (e) {
        /* noop */
      }
    }
    root.addEventListener('click', (e) => {
      const add = e.target.closest('.ps-card__add');
      const qtyBtn = e.target.closest('.ps-card__qty-btn');
      if (add) {
        const cell = add.closest('.ps-card__cart');
        change(cell.dataset.variantId, getQty(cell.dataset.variantId) + 1, cell);
      } else if (qtyBtn) {
        const cell = qtyBtn.closest('.ps-card__cart');
        const delta = qtyBtn.dataset.action === 'increase' ? 1 : -1;
        change(cell.dataset.variantId, getQty(cell.dataset.variantId) + delta, cell);
      }
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
        if (ev && ev.source === 'favorites') return;
        sync();
      });
    }
    return sync;
  }

  /* ---- Un-favourite removes the card; re-paginate; empty state when none ---- */
  function bindWishlist(root) {
    root.addEventListener('click', (e) => {
      const w = e.target.closest('.ps-card__wishlist');
      if (!w) return;
      const handle = w.dataset.productHandle;
      const list = read();
      const i = list.indexOf(handle);
      if (i > -1) {
        list.splice(i, 1);
        write(list);
        const card = w.closest('.ps-card');
        if (card) {
          card.style.transition = 'opacity 0.2s ease';
          card.style.opacity = '0';
        }
        setTimeout(() => {
          allCards = allCards.filter((c) => handleOf(c) !== handle);
          if (!allCards.length) {
            gridEl.innerHTML = '';
            navEl.innerHTML = '';
            if (emptyEl) emptyEl.hidden = false;
          } else {
            renderPage(Math.min(currentPage, totalPages()), false);
          }
        }, 200);
      } else {
        list.push(handle);
        write(list);
        w.classList.add('is-active');
      }
    });
  }

  /* Pagination clicks */
  function bindNav() {
    navEl.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-page]');
      if (btn) renderPage(parseInt(btn.dataset.page, 10), true);
    });
  }

  async function init() {
    rootEl = document.querySelector('[data-favorites]');
    if (!rootEl) return;
    gridEl = rootEl.querySelector('[data-favorites-grid]');
    navEl = rootEl.querySelector('[data-favorites-nav]');
    emptyEl = rootEl.querySelector('[data-favorites-empty]');
    perPage = parseInt(rootEl.dataset.perPage, 10) || 16;

    const handles = read();
    if (!handles.length) {
      if (emptyEl) emptyEl.hidden = false;
      return;
    }

    /* Tarjetas que ya vienen pintadas desde Liquid (cliente con sesión, ver
       sections/favorites-grid.liquid). Se adoptan tal cual en vez de volver a
       pedirlas: es lo que quita la espera y el hueco en blanco. Solo se piden al
       servidor las que falten — por ejemplo un favorito añadido en ESTE navegador
       que la cuenta todavía no tenía cuando se renderizó la página. */
    const pintadas = {};
    gridEl.querySelectorAll('.ps-card').forEach((card) => {
      const h = handleOf(card);
      if (h) pintadas[h] = card;
    });
    /* La rejilla NO se vacía aquí a propósito: si faltara alguna tarjeta por
       pedir, las que ya están pintadas desaparecerían mientras llega la
       respuesta. Se quedan a la vista y `renderPage` las recoloca al final. */

    /* Marca el corazón como activo: en la tarjeta del catálogo nace apagado y
       aquí, por definición, todo lo que se lista es un favorito. */
    const marcarCorazon = (card, h) => {
      const heart = card.querySelector('.ps-card__wishlist');
      if (!heart) return card;
      heart.classList.add('is-active');
      heart.setAttribute('aria-label', 'Quitar de favoritos');
      if (!heart.dataset.productHandle) heart.dataset.productHandle = h;
      return card;
    };

    /* La tarjeta REAL, la misma del catálogo (Section Rendering API), para que
       incluya los metacampos que el JSON de /products/{handle}.js no expone. */
    const pedirTarjeta = (h) =>
      fetch('/products/' + encodeURIComponent(h) + '?section_id=ps-card-fragment')
        .then((r) => (r.ok ? r.text() : null))
        .then((html) => {
          if (!html) return null;
          const card = new DOMParser().parseFromString(html, 'text/html').querySelector('.ps-card');
          return card ? marcarCorazon(card, h) : null;
        })
        .catch(() => null);

    const cards = await Promise.all(
      handles.map((h) => (pintadas[h] ? Promise.resolve(marcarCorazon(pintadas[h], h)) : pedirTarjeta(h))),
    );

    // Keep only the handles that resolved (drops stale / invalid entries).
    const valid = [];
    const cleanHandles = [];
    cards.forEach((c, idx) => {
      if (c) {
        valid.push(c);
        cleanHandles.push(handles[idx]);
      }
    });
    if (cleanHandles.length !== handles.length) write(cleanHandles);

    if (!valid.length) {
      if (emptyEl) emptyEl.hidden = false;
      return;
    }

    allCards = valid;

    cartSync = bindCart(rootEl);
    bindWishlist(rootEl);
    bindNav();
    renderPage(1, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
